/**
 * Typed endpoint definitions for the tags admin REST surface.
 *
 * Pattern mirrors admin-media-formats.endpoints.ts.
 *
 * Traceability: REQ-2.22
 */
import { z } from 'zod';
import { endpoint } from './endpoint.js';
import {
  TagDefinitionSchema,
  CreateTagSchema,
  UpdateTagSchema,
  DeleteTagEffectsSchema,
} from '../schemas/tag-definition.js';

const ListTagsQuerySchema = z.object({
  includeInactive: z.boolean().optional(),
});

export const tags = {
  /** GET /tags — list tag definitions; pass includeInactive=true to include deactivated tags (admin) */
  list: endpoint('GET', '/tags', ListTagsQuerySchema, z.array(TagDefinitionSchema)),

  /** POST /tags — create a new tag definition */
  create: endpoint('POST', '/tags', CreateTagSchema, TagDefinitionSchema),

  /** PATCH /tags/:id — update an existing tag definition */
  update: endpoint(
    'PATCH',
    '/tags/:id',
    z.object({ id: z.number() }).merge(UpdateTagSchema),
    TagDefinitionSchema,
  ),

  /** DELETE /tags/:id — soft-delete (sets is_active=false) */
  deactivate: endpoint('DELETE', '/tags/:id', z.object({ id: z.number() }), z.void()),

  /** GET /tags/:id/delete-effects — count of media units carrying the tag (confirm-dialog input) */
  getDeleteEffects: endpoint(
    'GET',
    '/tags/:id/delete-effects',
    z.object({ id: z.number() }),
    DeleteTagEffectsSchema,
  ),

  /** DELETE /tags/:id/permanent — hard-delete with cascade (removes the tag from all units) */
  deletePermanent: endpoint(
    'DELETE',
    '/tags/:id/permanent',
    z.object({ id: z.number() }),
    z.void(),
  ),
};
